shvenergy.faq = (function ($) {
	"use strict";

	function init() {
		var allFaqs = $('.faq');
        var slideTiming = 400;
		allFaqs.each(function () {
			var allHeaders = $(this).find(".faq__header");
			var allContent = $(this).find(".faq__content");
			allHeaders.each(function () {

				var header = $(this);
				var otherHeaders = allHeaders.not(header);

				header.on("click", function () {

					if (header.hasClass("selected")) {
						header.removeClass("selected").attr("aria-expanded", "false");
						allContent.slideUp(slideTiming);
						return;
					}

					header.addClass("selected").attr("aria-expanded", "true");
					otherHeaders.removeClass("selected").attr("aria-expanded", "false");
					allContent.slideUp(slideTiming);
					$(this).next(".faq__content").slideToggle(slideTiming, function () {
						
						
						
						var scrollTop = $(window).scrollTop();
						var headerOffsetTop = header.offset().top;
						var difference = headerOffsetTop - scrollTop;
						
						//if the expanded header is outside the viewport then slide it back in
						if (difference <= 100) {
							$("html, body").animate({ scrollTop: headerOffsetTop - 100 }, 350);
						}
						
						
					});

					if (shvenergy.tracking) {
						shvenergy.tracking.trackEvent('Accordion', 'Open', $(this).find(".faq__header__text").text());
					}
				});
			});
		});
	}

	init();

})(jQuery);